export var ContentV1;
(function (ContentV1) {
    let MediaProvider;
    (function (MediaProvider) {
        MediaProvider["S3"] = "S3";
        MediaProvider["Local"] = "Local";
    })(MediaProvider = ContentV1.MediaProvider || (ContentV1.MediaProvider = {}));
})(ContentV1 || (ContentV1 = {}));
